import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import BannerImgDesk from "./assets/ChandanYatraBG.webp";
import thirdbg from "./assets/bg3.webp";
import "./ChandanYatra.css";
import axios from "axios";
import barcode1 from "./assets/barcode1.webp";
import barcode2 from "./assets/barcode2.webp";
import { Helmet } from "react-helmet";

function ChandanYatra() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    chandanSeva: false,
    garlandSeva: false,

    sevaDate: "",
    honoureeName: "",
    relationship: "",
    donorName: "",
    email: "",
    mobile: "",
    dob: "",
    receive80G: false,
    panNumber: "",
    receiveMahaPrasadam: false,

    selectedChandanSevaAmount: null,
    selectedGarlandSevaAmount: null,

    customChandanSevaAmount: "",
    customGarlandSevaAmount: "",

    mahaPrasadamDetails: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "customChandanSevaAmount" && value) {
        updatedData.selectedChandanSevaAmount = parseFloat(value);
      } else if (name === "customGarlandSevaAmount" && value) {
        updatedData.selectedGarlandSevaAmount = parseFloat(value);
      }

      return updatedData;
    });
  };

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleAmountSelect = (section, amount) => {
    setFormData((prevData) => {
      switch (section) {
        case "chandanSeva":
          return {
            ...prevData,
            selectedChandanSevaAmount:
              prevData.selectedChandanSevaAmount === amount ? null : amount,
            customChandanSevaAmount: "",
          };
        case "garlandSeva":
          return {
            ...prevData,
            selectedGarlandSevaAmount:
              prevData.selectedGarlandSevaAmount === amount ? null : amount,
            customGarlandSevaAmount: "",
          };
        default:
          return prevData;
      }
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.donorName) newErrors.donorName = "Donor name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (formData.receive80G && !formData.panNumber)
      newErrors.panNumber = "PAN number is required for 80G certificate";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getTotalAmount = () => {
    const chandanSevaAmount =
      formData.selectedChandanSevaAmount ||
      parseFloat(formData.customChandanSevaAmount) ||
      0;
    const garlandSevaAmount =
      formData.selectedGarlandSevaAmount ||
      parseFloat(formData.customGarlandSevaAmount) ||
      0;
    return chandanSevaAmount + garlandSevaAmount;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const totalAmount = getTotalAmount();
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: totalAmount,
          currency: "INR",
        }
      );

      const order = response.data;
      let sevaDescription = "Donation Payment";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Guru Purnima Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donorName: formData.donorName,
          donorPhoneNumber: formData.mobile,
          donorEmail: formData.email,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData, amount: totalAmount },
              }
            );

            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (!isFormDataStored) {
                await storeFormData("Payment Successful");
                isFormDataStored = true;
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const totalDonationAmount = getTotalAmount();

    // Prepare data in the format expected by your Apps Script
    const formDataToSend = new URLSearchParams();

    // Add all fields to the form data
    formDataToSend.append("paymentStatus", paymentStatus);

    formDataToSend.append("chandanSeva", formData.chandanSeva ? "Yes" : "No");
    formDataToSend.append(
      "chandanSevaAmount",
      formData.selectedChandanSevaAmount ||
        formData.customChandanSevaAmount ||
        0
    );
    formDataToSend.append("garlandSeva", formData.garlandSeva ? "Yes" : "No");
    formDataToSend.append(
      "garlandSevaAmount",
      formData.selectedGarlandSevaAmount ||
        formData.customGarlandSevaAmount ||
        0
    );

    formDataToSend.append("totalDonationAmount", totalDonationAmount);
    formDataToSend.append("sevaDate", formData.sevaDate || "");
    formDataToSend.append("honoureeName", formData.honoureeName || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("donorName", formData.donorName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("receive80G", formData.receive80G ? "Yes" : "No");
    formDataToSend.append(
      "panNumber",
      formData.receive80G ? formData.panNumber : ""
    );
    formDataToSend.append(
      "receiveMahaPrasadam",
      formData.receiveMahaPrasadam ? "Yes" : "No"
    );
    formDataToSend.append(
      "doorNumber",
      formData.mahaPrasadamDetails.doorNumber || ""
    );
    formDataToSend.append(
      "houseName",
      formData.mahaPrasadamDetails.houseName || ""
    );
    formDataToSend.append(
      "streetName",
      formData.mahaPrasadamDetails.streetName || ""
    );
    formDataToSend.append("area", formData.mahaPrasadamDetails.area || "");
    formDataToSend.append(
      "country",
      formData.mahaPrasadamDetails.country || ""
    );
    formDataToSend.append("state", formData.mahaPrasadamDetails.state || "");
    formDataToSend.append("city", formData.mahaPrasadamDetails.city || "");
    formDataToSend.append(
      "pincode",
      formData.mahaPrasadamDetails.pincode || ""
    );

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbxO7QUboSMhr3dWCv0k_gqMzBZcgP329r3Sxht_Ma19dIL8XRLtDy278bPUPi-qhw3JXQ/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDataToSend.toString(),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      console.log("Data stored successfully in Google Sheets");
      return true;
    } catch (error) {
      console.error("Error storing data:", error);
      alert(
        "An error occurred while storing your donation details. Please try again."
      );
      return false;
    }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const [copiedText, setCopiedText] = useState(null);
  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Chandan Yatra 2025 at ISKCON Vijayawada | Participate in the Sacred
          Festival
        </title>
        <meta
          name="description"
          content="Join ISKCON Vijayawada’s Chandan Yatra 2025 – a divine celebration where Lord Krishna is adorned with sandalwood paste. Experience bhajans, prasadam, and spiritual bliss."
        />
        <meta
          name="keywords"
          content="Chandan Yatra 2025 iskcon,  ISKCON Vijayawada, Akshaya Tritiya 2025, Lord Jagannath, Krishna festival 2025, sandalwood festival 2025, Hindu festivals, temple events, devotional celebrations, Radha Shyamsundar, ISKCON festivals, spiritual events, Vijayawada temple, Chandan Yatra 2025, ISKCON India, sandalwood festival 2025 iskcon vijayawada"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Chandan Yatra 2025 at ISKCON Vijayawada | Participate in the Sacred Festival"
        />
        <meta
          property="og:description"
          content="Join ISKCON Vijayawada’s Chandan Yatra 2025 – a divine celebration where Lord Krishna is adorned with sandalwood paste. Experience bhajans, prasadam, and spiritual bliss."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/ChandanYatra"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Chandan Yatra 2025 at ISKCON Vijayawada | Participate in the Sacred Festival"
        />
        <meta
          name="twitter:description"
          content="Join ISKCON Vijayawada’s Chandan Yatra 2025 – a divine celebration where Lord Krishna is adorned with sandalwood paste. Experience bhajans, prasadam, and spiritual bliss."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
      </Helmet>

      <Header />
      <div className="ramnavami-container">
        <div className="ramnavami-banner">
          <img
            loading="lazy"
            src={BannerImgDesk}
            alt="main Img"
            className="md:mt-[45px] chandanyatra-banner-img"
          />
        </div>
        <div
          className="ramnavami-content-bg "
          style={{ backgroundImage: `url(${thirdbg})` }}
        >
          <div className="ChandanYatra-section-heading">
            <h1 className="ChandanYatra-heading">
              Chandan Yatra – A Cooling Festival for Lord Krishna
            </h1>
            <h2 className="ChandanYatra-subheading">
              Participate in the Joyful Tradition of Sandalwood Worship
            </h2>
          </div>
          <div className="ramnavami-content">
            <h2 className="ramnavami-headline">Chandan Yatra 2025</h2>
            <h2 className="ramnavami-subheadline">
              A Grand Celebration at ISKCON Vijayawada
            </h2>
            <div className="ramnavami-text-container">
              <div className="ramnavami-text-content ">
                <p>
                  Chandan Yatra is one of the most intimate and loving services
                  offered to Lord Sri Sri Radha Syamasundara at ISKCON
                  Vijayawada. Starting on the auspicious occasion of Akshaya
                  Tritiya, this 21-day festival sees Their Lordships adorned
                  with cooling sandalwood paste, offering them relief from the
                  summer heat.
                </p>

                <p>
                  This is a rare and blessed opportunity for you to serve the
                  Lord personally and receive His unlimited mercy!
                </p>

                <p>
                  By participating in this once-a-year festival, you become a
                  direct part of this sacred tradition at ISKCON Vijayawada!
                </p>

                {/* <div className="ramnavami-event-details">
                  <p><strong>📅 Date:</strong> 6th April 2025</p>
                  <p><strong>⏰ Time:</strong> From 9:00 AM onwards</p>
                  <p><strong>📍 Venue:</strong> ISKCON SRI RADHA SHYAMSUNDAR MANDIR</p>
                </div> */}

                <h1 className="text-2xl text-center font-bold my-4">
                  Choose Your Special Seva & Receive Personalized Blessings!
                </h1>
              </div>
            </div>
          </div>

          <div className="flex justify-center pb-4 px-4">
            <div className="justify-center md:w-[60%]">
              <div className="donationDetail bg-[#C61D21] py-10 px-2 rounded-3xl xl:h-full xl:p-8  xl:max-w-[1400px] w-full">
                <form onSubmit={handleSubmit} className="text-white">
                  <h2 className="text-center text-2xl xl:text-4xl">
                    Donation Details
                  </h2>

                  <div className="innerForm sevaContainer">
                    {/* Chandan Seva */}
                    <label>
                      <input
                        type="checkbox"
                        name="chandanSeva"
                        checked={formData.chandanSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Chandan Seva
                    </label>
                    {formData.chandanSeva && (
                      <>
                        <div className="grid grid-cols-2 -mt-4">
                          {[
                            { money: 501, text: "One Bowl, One Blessing" },
                            { money: 11000, text: "Complete Chandan Seva" },
                          ].map((amount) => (
                            <button
                              className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                              type="button"
                              key={amount.money}
                              onClick={() =>
                                handleAmountSelect("chandanSeva", amount.money)
                              }
                              style={{
                                backgroundColor:
                                  formData.selectedChandanSevaAmount ===
                                  amount.money
                                    ? "#fac785"
                                    : "",
                                margin: "5px",
                              }}
                            >
                              ₹ {amount.money.toLocaleString("en-IN")}/-{" "}
                              {amount.text}
                            </button>
                          ))}
                          <input
                            type="number"
                            name="customChandanSevaAmount"
                            placeholder="₹ Enter Amount"
                            value={formData.customChandanSevaAmount || ""}
                            onChange={handleInputChange}
                            className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                          />
                        </div>
                      </>
                    )}

                    {/* Garland Seva */}
                    <label>
                      <input
                        type="checkbox"
                        name="garlandSeva"
                        checked={formData.garlandSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Garland Seva
                    </label>
                    {formData.garlandSeva && (
                      <>
                        <div className="grid grid-cols-2 -mt-4">
                          {[2000].map((amount) => (
                            <button
                              className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                              type="button"
                              key={amount}
                              onClick={() =>
                                handleAmountSelect("garlandSeva", amount)
                              }
                              style={{
                                backgroundColor:
                                  formData.selectedGarlandSevaAmount === amount
                                    ? "#fac785"
                                    : "",
                                margin: "5px",
                              }}
                            >
                              ₹ {amount.toLocaleString("en-IN")}/- "Garland of
                              Grace"
                            </button>
                          ))}
                          <input
                            type="number"
                            name="customGarlandSevaAmount"
                            placeholder="₹ Enter Amount"
                            value={formData.customGarlandSevaAmount || ""}
                            onChange={handleInputChange}
                            className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="innerForm">
                    <h3 className="text-center">Personal Details</h3>
                    <label className="xl:w-full">
                      <input
                        type="text"
                        name="donorName"
                        value={formData.donorName}
                        onChange={handleInputChange}
                        placeholder="Donor Name"
                        className="mt-2"
                      />
                      {errors.donorName && (
                        <span className="block -mt-2 ml-2">
                          {errors.donorName}
                        </span>
                      )}
                    </label>
                    <label className="xl:w-full">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Email ID"
                      />
                      {errors.email && (
                        <span className="block -mt-2 ml-2">{errors.email}</span>
                      )}
                    </label>
                    <div className="flex gap-2">
                      <label className="flex-1">
                        <input
                          type="tel"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleInputChange}
                          placeholder="Mobile Number"
                          className="p-[10px] md:w-full"
                        />
                        {errors.mobile && (
                          <span className="block mt-1 ml-2">
                            {errors.mobile}
                          </span>
                        )}
                      </label>
                      <label className="flex-1">
                        <input
                          type="text"
                          name="dob"
                          value={formData.dob}
                          onChange={handleInputChange}
                          className="text-[#909192] p-2 border rounded-md"
                          placeholder="Date Of Birth"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => (e.target.type = "text")}
                        />
                        {errors.dob && (
                          <span className="block -mt-2 ml-2">{errors.dob}</span>
                        )}
                      </label>
                    </div>
                  </div>
                  <p className="text-white mt-2 text-[10px]">
                    (Sankalpa and Archana will be performed for you on your
                    birthday)
                  </p>

                  <p className="text-white -mt-2 text-xs">
                    By continuing, you are agreeing to{" "}
                    <a className="underline text-[#EEF9A3]">
                      Terms of Use and Privacy Policy
                    </a>
                  </p>

                  <div className="px-3 tandd mt-8">
                    <label>
                      <input
                        type="checkbox"
                        name="receive80G"
                        checked={formData.receive80G}
                        onChange={handle80GCheckboxChange}
                        style={{ accentColor: "blue" }}
                      />
                      I would like to receive 80(G) Certificate
                    </label>
                    {show80GDetails && (
                      <div className="mb-3">
                        <p className="text-white text-[10px] text-left ml-2">
                          Finance Act 2021 mandates uploading donation details
                          for 80(G) deductions. Ensure PAN and address details
                          are provided.
                        </p>
                        <input
                          type="text"
                          name="panNumber"
                          value={formData.panNumber}
                          onChange={handleInputChange}
                          placeholder="Pan Number *"
                          className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                          required
                        />
                        <input
                          type="text"
                          name="doorNumber"
                          placeholder="Door Number"
                          className="text-black"
                          value={formData.mahaPrasadamDetails.doorNumber}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                doorNumber: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="houseName"
                          placeholder="House / Apartment / Building Name"
                          value={formData.mahaPrasadamDetails.houseName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                houseName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="streetName"
                          placeholder="Street Name"
                          value={formData.mahaPrasadamDetails.streetName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                streetName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="area"
                          placeholder="Location / Area"
                          value={formData.mahaPrasadamDetails.area}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                area: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="country"
                          placeholder="Country"
                          value={formData.mahaPrasadamDetails.country}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                country: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="state"
                          placeholder="State"
                          value={formData.mahaPrasadamDetails.state}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                state: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="city"
                          placeholder="City"
                          value={formData.mahaPrasadamDetails.city}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                city: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="pincode"
                          placeholder="Pincode"
                          value={formData.mahaPrasadamDetails.pincode}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                pincode: e.target.value,
                              },
                            }))
                          }
                        />
                      </div>
                    )}

                    <label>
                      <input
                        type="checkbox"
                        name="receiveMahaPrasadam"
                        checked={formData.receiveMahaPrasadam}
                        onChange={handleMahaPrasadamCheckboxChange}
                        style={{ accentColor: "blue" }}
                      />
                      I would like to receive Maha prasadam (Only within India)
                    </label>
                    {showMahaPrasadamDetails && (
                      <div className="mt-3">
                        <input
                          type="text"
                          name="doorNumber"
                          placeholder="Door Number"
                          className="text-black"
                          value={formData.mahaPrasadamDetails.doorNumber}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                doorNumber: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="houseName"
                          placeholder="House / Apartment / Building Name"
                          value={formData.mahaPrasadamDetails.houseName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                houseName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="streetName"
                          placeholder="Street Name"
                          value={formData.mahaPrasadamDetails.streetName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                streetName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="area"
                          placeholder="Location / Area"
                          value={formData.mahaPrasadamDetails.area}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                area: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="country"
                          placeholder="Country"
                          value={formData.mahaPrasadamDetails.country}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                country: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="state"
                          placeholder="State"
                          value={formData.mahaPrasadamDetails.state}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                state: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="city"
                          placeholder="City"
                          value={formData.mahaPrasadamDetails.city}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                city: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="text-black"
                          name="pincode"
                          placeholder="Pincode"
                          value={formData.mahaPrasadamDetails.pincode}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                pincode: e.target.value,
                              },
                            }))
                          }
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex justify-center mt-8">
                    <button
                      type="submit"
                      className="bg-[#FAE29C] text-black px-12 py-3 rounded-2xl font-bold"
                    >
                      Donate{" "}
                      {getTotalAmount() > 0
                        ? "₹ " + getTotalAmount().toLocaleString("en-IN")
                        : ""}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* donation Through Bank */}
          <div className="mx-2">
            <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-5 justify-center items-center  overflow-hidden">
              <h2 className="md:py-4 py-3 bg-[#C61D21] text-white text-center md:text-3xl text-base">
                Donation Through Bank (NEFT/RTGS){" "}
              </h2>
              <div className="flex justify-center items-center">
                <ul className="flex flex-col justify-center items-center leading-4 space-y-4 list-none px-0 mx-0  my-2">
                  <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                    <span className="md:text-2xl text-[15px] text-[#C61D21] ">
                      Bank Name:<span className="text-black"> HDFC Bank</span>
                    </span>{" "}
                    <button
                      class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                      onClick={() => copyToClipboard("HDFC Bank", "bankName")}
                    >
                      {copiedText === "bankName" ? "Copied!" : "Copy"}
                    </button>
                  </li>

                  <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                    <span className="md:text-2xl text-[15px] text-[#C61D21]">
                      Account Name:<span className="text-black"> ISKCON</span>
                    </span>{" "}
                    <button
                      class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5  border-1 border-[#C61D21] ml-2 rounded-full"
                      onClick={() => copyToClipboard("ISKCON", "accountName")}
                    >
                      {copiedText === "accountName" ? "Copied!" : "Copy"}
                    </button>
                  </li>
                  <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                    <span className=" text-[#C61D21]">
                      Account Number:{" "}
                      <span className="text-black">50100436709020</span>
                    </span>{" "}
                    <button
                      class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                      onClick={() =>
                        copyToClipboard("50100436709020", "accountNumber")
                      }
                    >
                      {copiedText === "accountNumber" ? "Copied!" : "Copy"}
                    </button>
                  </li>
                  <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal ">
                    <span className=" text-[#C61D21]">
                      IFSC Code: <span className="text-black">HDFC000568</span>
                    </span>
                    <button
                      class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                      onClick={() => copyToClipboard("HDFC000568", "ifscCode")}
                    >
                      {copiedText === "ifscCode" ? "Copied!" : "Copy"}
                    </button>
                  </li>
                  <li className="w-full md:text-2xl text-[15px] leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                    <span className=" text-[#C61D21]">
                      Branch:{" "}
                      <span className="text-black">ONE TOWN VIJAYAWADA </span>
                    </span>{" "}
                    <button
                      class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                      onClick={() =>
                        copyToClipboard("ONE TOWN VIJAYAWADA", "branch")
                      }
                    >
                      {copiedText === "branch" ? "Copied!" : "Copy"}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* UPI Payment */}
          <div className="mx-2">
            <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-10 overflow-hidden">
              <h2 className="md:py-4 py-2 bg-[#C61D21] text-white text-center md:text-3xl text-base">
                Donate Through UPI
              </h2>

              <div className="flex md:flex-row flex-col justify-around items-center pt-3 md:pb-3 pb-4 gap-4">
                <div className="md:block flex gap-2 px-1">
                  <h2 className="md:text-2xl text-sm text-[#C61D21]">
                    UPI ID:
                  </h2>
                  <p className="md:text-xl text-sm  text-black">
                    {" "}
                    ISCKONVIJAYAWADA@IDFCBANK
                  </p>
                </div>
                <img
                  loading="lazy"
                  src={barcode1}
                  alt=""
                  width="200px"
                  height="200px"
                />
                <span className="font-bold">OR</span>
                <img
                  loading="lazy"
                  src={barcode2}
                  alt=""
                  width="200px"
                  height="200px"
                />
              </div>
            </div>

            <div className="text-left md:mx-44 mt-5 pb-10">
              <h2 className="text-3xl  text-[#C61D21] text-left font-bold">
                After Donation:
              </h2>
              <p className="md:text-2xl mt-4 text-base text-black w-full text-justify font-semibold">
                Once you have donated, please share the transaction details or
                receipt via WhatsApp at{" "}
                <span className="text-red">+91 9955685568</span>. This helps us
                acknowledge your contribution and issue a receipt for tax
                exemption under Section 80G of the Income Tax Act.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ChandanYatra;
